import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Contact } from '../../../../core/models/civi-crm/contact/contact';

@Component({
    selector: 'app-spectrum-advisor-info',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './spectrum-advisor-info.component.html',
})
export class SpectrumAdvisorInfoComponent {
    @Input() advisorContact: Contact | null = null;
}
